var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dropdown"},[_c('iv-button',{staticClass:"card-collapse-button",class:{ 'card-close': !_vm.innateValue },attrs:{"pill":"","equal":"","size":"sm","variant":"light","icon":"fa-solid fa-chevron-up"},on:{"click":_vm.toggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }